/**
 * Firestore utilities
 */
import { getFirestore } from 'firebase/firestore';
import { initializeFirebase } from './config.js';
let firestoreInstance = null;
/**
 * Get Firestore instance
 */
export function getFirestoreInstance() {
    if (!firestoreInstance) {
        initializeFirebase();
        firestoreInstance = getFirestore();
    }
    return firestoreInstance;
}
//# sourceMappingURL=firestore.js.map